export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig();

  const api = $fetch.create({
    baseURL: runtimeConfig.public.apiUrl + "/api/v1/auth",
    onRequest({ options }) {
      if (!options.headers.has("Accept")) {
        options.headers.set("Accept", "application/json");
      }
    },
  });

  // Expose to useNuxtApp().$api
  return {
    provide: {
      api,
    },
  };
});
